import React from "react"
import styled from "styled-components"
import { Link } from "gatsby"
import { textButton } from "../Styles/TextStyles"

function MenuButton(props) {
  const { item } = props
  return (
    <Link to={item.link}>
      <MenuItem hasTitle={!item.title !== "" ? false : true}>
        <img src={item.icon} alt="icon menu" />
        <Text>
        {item.title}</Text>
      </MenuItem>
    </Link>
  )
}

export default MenuButton

const MenuItem = styled.div`
  color: rgba(255, 255, 255, 0.7);
  display: grid;
  grid-template-columns:
    auto auto
    auto;
  padding-top: ${props => (props.hasTitle ? "15px" : "15px")};
  padding-left: ${props => (props.hasTitle ? "15px" : "5px")};
  padding-right: ${props => (props.hasTitle ? "15px" : "5px")};
  padding-bottom: ${props => (props.hasTitle ? "15px" : "15px")};
  border-radius: 10px;
  align-self: center;
  align-content: center;
  align-items: center;
  transition: 0.5s ease-in-out;

  :hover {
    background: rgba(255, 255, 255, 0.1);
    box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.1),
      inset 0px 0px 0px 0.5px rgba(255, 255, 255, 0.2);
      filter: saturate(150%) brightness(100%);
      
  }
`
const Text = styled(textButton)`
color: whitesmoke;
font-size: 20px;
`